import { ThemeText } from '@/components/Theme/ThemeText';
import { READABLE_DATETIME_FORMAT } from '@/constants/DateTime';
import { format as formatDate } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { toDate } from 'date-fns/toDate';

export const ThemeDate = ({date = null, format = null, ...rest}) => {

    try {
        const parsedDate = toDate(date);
        
        if (isValid(parsedDate))
            return <ThemeText {...rest}>{formatDate(parsedDate, format ?? READABLE_DATETIME_FORMAT())}</ThemeText>

        return null;
        

    } catch (e) {
        console.error(e);
        return null;
    }

};